import { getServiceNameFromUrl } from './services';
export { getServiceNameFromUrl } from './services';
export default (config => {
  // While using miagejs server I noticed that it didn't return config object
  // during error cases, this code was eating actual error and throwing "can't
  // access url on undefined" error that made it difficult to identify the
  // real issue. That was non productive for me.
  // While using request interceptor to cancel request during scoped unit tests,
  // axios returns an error that doesn't have config and this code fails.
  // Since this was surfaced in testing, add a check for config to be safe.
  if (config === undefined) {
    // possible during tests.
    return null;
  }
  return getServiceNameFromUrl(config.url);
});
//# sourceMappingURL=getServiceName.js.map